<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addAmmeter" v-if="permissionCodes.indexOf('045002005') !== -1" />
        <button-upload :cathUrl="uploadUrl" :onSuccess="onUploadSuccess" v-if="permissionCodes.indexOf('045002009') !== -1" @getpage="getPage" value="导入" />
        <button-export :href="exportUrl" :beforeDownload="beforeDownload" download="download.xls" v-if="permissionCodes.indexOf('045002010') !== -1" value="导出" />
        <button-export :href="exportTipUrl" :beforeDownload="beforeTipDownload" download="download.xls" value="导出标签" />
      </div>
      <input-search placeholder="蒸汽表名称/住户/集中器名称" @search="searchKey" />
    </div>

    <div class="search-line">
      <div style="display: flex; justify-content: flex-start">
        <input-select selectTitle="集中器" :selectKey="'steamControlDeviceCode'" selectWidth="120px" :selectData="steamList" @search="search" style="margin-right: 10px" />
      </div>
      <div style="display: flex; justify-content: flex-start">
        <input-select selectTitle="设备状态" :selectKey="'deviceStatus'" selectWidth="100px" :selectData="deviceStatusList" @search="search" style="margin-right: 10px" />
        <input-select selectTitle="蒸汽类型" :selectKey="'useType'" selectWidth="100px" :selectData="useTypeList" @search="search" />
      </div>
    </div>

    <table-main :selection="false" :tableWidth="'140%'" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @lookOver="lookOver" @deleteLine="deleteLine" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @changeSwitch="changeSwitch" @changeSwitch2="changeSwitch2" @getAmmeterTip="getAmmeterTip" :tableOperationWidth="'300px'" :operationArr="operationArr" :operationFixed="'right'" />

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">
            <div style="text-align: left; margin: 10px 0 20px 0">
              <el-date-picker v-model="steamityTimeArr" size="small" type="datetimerange" :picker-options="pickerOptions2" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
            </div>
            <table-main :selection="false" :hasOperation="false" :tableHead="steamityTableHead" :tableData="steamityTableData" :total="steamityTotal" :pageNum="steamityPageNum" :pageSize="steamityPageSize" @changePagination="changesteamityPagination" />
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

    <el-dialog title="标签" :visible.sync="tipDialogVisible" width="40%">
      <div style="margin: 20px 0">
        <canvas class="qrcode" ref="qrCodeUrl" id="createCode"></canvas>
        <div style="width: 280px; margin: 0 auto; text-align: center; font-size: 18px">{{ currentsteamDeviceName }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="closeTipDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QrCodeWithLogo from 'qr-code-with-logo'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import { api } from '../../api/SteamManagement'
import { errorHandler } from '../../../utils/errorHandler'
import { nAlert, nSuccess } from '../../../utils/notice'
import { bus } from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb,
  },
  name: 'controller-management',
  data() {
    return {
      permissionCodes: '',
      breadcrumb: [
        {
          value: '智慧蒸汽',
          name: 'steam-over-view',
        },
        {
          value: '蒸汽表管理',
        },
      ],
      addAmmeter: 'steam-ammeter-add',
      uploadUrl: '',
      exportUrl: '',
      exportTipUrl: '',
      // tableHead: [{
      //   prop: 'name',
      //   label: '蒸汽表名称',
      // }, {
      //   prop: 'steamDeviceType',
      //   label: '蒸汽表类型',
      //   width: '80'
      // }, {
      //   prop: 'rentName',
      //   label: '住户',
      // }, {
      //   prop: 'accessType',
      //   label: '接入方式',
      // }, {
      //   prop: 'steamControlDeviceName',
      //   label: '集中器名称',
      // }, {
      //   prop: 'sceneName',
      //   label: '场景',
      //   width: '80'
      // }, {
      //   prop: 'buildingRoomName',
      //   label: '所在房间',
      //   width: '120'
      // }, {
      //   prop: 'deviceStatus',
      //   isStatus: true,
      //   label: '蒸汽表状态',
      //   width: '80'
      // }, {
      //   prop: 'autoOffState',
      //   label: '欠费关闸',
      //   active: '是',
      //   inactive: '否',
      //   isSwitch2: true,
      //   width: '120'
      // }, {
      //   prop: 'powerOnOrOffState',
      //   label: '手动开关闸',
      //   active: '开',
      //   inactive: '关',
      //   isSwitch: true,
      //   width: '120'
      // }, {
      //   isLooking: true,
      //   label: '历史蒸汽量',
      //   width: '80'
      // }],
      tableHead: [],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],

      deviceStatusList: [
        {
          key: '',
          label: '全部',
        },
        {
          key: '1',
          label: '在线',
        },
        {
          key: '0',
          label: '离线',
        },
      ],
      useTypeList: [
        {
          key: '',
          label: '全部',
        },
        {
          key: '1',
          label: '充值',
        },
        {
          key: '2',
          label: '抄表',
        },
      ],
      requestData: {
        searchKey: '',
        deviceStatus: '',
        useType: '',
        steamControlDeviceCode: '',
      },
      operationArr: ['current', 'ammeterTip', 'delete'],
      windowLeftBox: false,
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000)
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      steamityTableHead: [
        {
          prop: 'steamDeviceName',
          label: '蒸汽表名称',
        },
        {
          prop: 'timestamp',
          label: '上报时间',
        },
        {
          prop: 'steamity',
          label: '蒸汽表读数(吨)',
        },
        {
          prop: 'usedSteamity',
          label: '使用蒸汽量(吨)',
        },
      ],
      steamityTableData: [],
      steamDeviceCode: '',
      steamityTotal: 0,
      steamityPageSize: 10,
      steamityPageNum: 1,
      steamityTimeArr: [],

      steamList: [],

      tipDialogVisible: false,
      tipContent: '',
      currentsteamDeviceName: '',

      levelList: [
        {
          key: '',
          label: '全部',
        },
        {
          label: '一级',
          key: 1,
        },
        {
          label: '二级',
          key: 2,
        },
        {
          label: '三级',
          key: 3,
        },
        {
          label: '四级',
          key: 4,
        },
        {
          label: '五级',
          key: 5,
        },
      ],
    }
  },
  created() {
    this.autoOffSupport()
    this.permissionCodes = bus.global.permissionCodes
    // this.uploadUrl = api.importsteamMeter
    // // this.exportUrl = `${api.exportsteamMeter}?yq-app-code=${bus.global.yqCode}&kj-type=gy`

    // this.getCreateTime()
    this.getsteamManagerList()
  },
  activated() {
    this.autoOffSupport()
    this.getsteamManagerList()
  },
  methods: {
    // 查询是否可配置欠费是否关闸
    autoOffSupport() {
      this.$axios
        .get(api.autoOffSupport, {})
        .then((res) => {
          let autoOffSupportState = res.data.data
          if (autoOffSupportState) {
            this.tableHead = [
              {
                prop: 'name',
                label: '蒸汽表名称',
              },
              // {
              //   prop: 'steamDeviceType',
              //   label: '蒸汽表类型',
              //   width: '80',
              // },
              {
                prop: 'levelName',
                label: '蒸汽表级别',
              },
              {
                prop: 'rentName',
                label: '住户',
              },
              {
                prop: 'accessType',
                label: '接入方式',
              },
              {
                prop: 'steamControlDeviceName',
                label: '集中器名称',
              },
              // {
              //   prop: 'mutualInductorText',
              //   label: '互感器配置',
              //   width: '100',
              // },
              // {
              //   prop: 'powerRate',
              //   label: '倍率',
              // },
              {
                prop: 'sceneName',
                label: '场景',
              },
              {
                prop: 'useTypeName',
                label: '蒸汽类型',
              },
              {
                prop: 'buildingRoomName',
                label: '所在房间',
              },
              {
                prop: 'deviceStatus',
                isStatus: true,
                label: '蒸汽表状态',
              },
              {
                prop: 'autoOffState',
                label: '欠费关闸',
                active: '是',
                inactive: '否',
                isSwitch2: true,
              },
              {
                prop: 'powerOnOrOffState',
                label: '手动开关闸',
                active: '开',
                inactive: '关',
                isSwitch: true,
              },
              {
                isLooking: true,
                label: '历史蒸汽量',
              },
            ]
          } else {
            this.tableHead = [
              {
                prop: 'name',
                label: '蒸汽表名称',
              },
              // {
              //   prop: 'steamDeviceType',
              //   label: '蒸汽表类型',
              //   width: '80',
              // },
              {
                prop: 'levelName',
                label: '蒸汽表级别',
              },
              {
                prop: 'rentName',
                label: '住户',
              },
              {
                prop: 'accessType',
                label: '接入方式',
              },
              {
                prop: 'steamControlDeviceName',
                label: '集中器名称',
              },
              {
                prop: 'mutualInductorText',
                label: '互感器配置',
              },
              // {
              //   prop: 'powerRate',
              //   label: '倍率',
              // },
              {
                prop: 'sceneName',
                label: '场景',
              },
              {
                prop: 'useTypeName',
                label: '蒸汽类型',
              },
              {
                prop: 'buildingRoomName',
                label: '所在房间',
              },
              {
                prop: 'deviceStatus',
                isStatus: true,
                label: '蒸汽表状态',
              },
              {
                isLooking: true,
                label: '历史蒸汽量',
              },
            ]
          }
          this.getPage()
        })
        .catch(errorHandler('查询配置信息失败'))
    },
    beforeDownload() {
      this.exportUrl = `${api.exportSteamMeterDevice}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&deviceStatus=${this.requestData.deviceStatus}&useType=${this.requestData.useType}&steamControlDeviceCode=${this.requestData.steamControlDeviceCode}`
    },
    beforeTipDownload() {
      this.exportTipUrl = `${api.exportCodeScanning}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&deviceStatus=${this.requestData.deviceStatus}&useType=${this.requestData.useType}&steamControlDeviceCode=${this.requestData.steamControlDeviceCode}`
    },
    // 获取集中器列表
    getsteamManagerList() {
      this.$axios
        .post(api.getSteamControlDeviceList, {})
        .then((res) => {
          let list = res.data.data
          list.map((v) => {
            v.key = v.deviceCode
            v.label = v.name
          })
          list.unshift({
            key: '',
            label: '全部',
          })
          this.steamList = list
        })
        .catch(errorHandler('获取集中器列表失败'))
    },
    getCreateTime() {
      let nowDate = new Date()
      let year = nowDate.getFullYear()
      let month = nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
      let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.steamityTimeArr[0] = year + '-' + month + '-01' + ' ' + '00:00:00'
      this.steamityTimeArr[1] = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    getPage() {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios
        .post(api.getSteamMeterDevicePage, reqData)
        .then((res) => {
          let data = res.data.data.list
          data.map((v) => {
            this.levelList.map((level) => {
              if (v.level === level.key) {
                v.levelName = level.label
              }
            })
            if (v.buildingName && v.roomNumber) {
              v.buildingRoomName = `${v.buildingName}${v.roomNumber}`
            } else {
              v.buildingRoomName = ''
            }
            if (v.powerOnOrOff === '1') {
              v.powerOnOrOffState = true
            } else {
              v.powerOnOrOffState = false
            }
            if (v.autoOff === '1') {
              v.autoOffState = true
            } else {
              v.autoOffState = false
            }
            if (v.scene === '1') {
              v.sceneText = '公共蒸汽'
            } else if (v.scene === '2') {
              v.sceneText = '机房蒸汽'
            } else if (v.scene === '3') {
              v.sceneText = '租房蒸汽'
            }
            if (v.useType === '1') {
              v.useTypeName = '充值'
            } else {
              v.useTypeName = '抄表'
            }
            if (v.mutualInductorOnOrOff === '1') {
              v.mutualInductorText = '是'
            } else {
              v.mutualInductorText = '否'
            }
          })
          this.total = res.data.data.total
          this.tableData = data
        })
        .catch(errorHandler('获取蒸汽表数据失败'))
    },
    search(v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey(v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination(data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changesteamityPagination(data) {
      this.steamityPageNum = data[0]
      this.steamityPageSize = data[1]
      this.getsteamityPage()
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess('导入成功')
        this.pageSize = 10
        this.pageNum = 1
        this.getPage()
      } else {
        errorHandler('导入失败')(data)
      }
    },
    // 查询蒸汽表蒸汽量
    lookOver(row) {
      this.steamDeviceCode = row.code
      this.getsteamityPage()
    },
    getsteamityPage() {
      let startTime = ''
      let endTime = ''
      if (this.steamityTimeArr) {
        startTime = this.steamityTimeArr[0]
        endTime = this.steamityTimeArr[1]
      } else {
        startTime = ''
        endTime = ''
      }
      this.$axios
        .post(api.steamSupply, {
          pageSize: this.steamityPageSize,
          pageNum: this.steamityPageNum,
          startTime: startTime,
          endTime: endTime,
          steamDeviceCode: this.steamDeviceCode,
        })
        .then((res) => {
          this.windowLeftBox = true
          let data = res.data.data
          this.steamityTableData = data.list
          this.steamityTotal = data.total
        })
        .catch(errorHandler('查询蒸汽表蒸汽量失败'))
    },
    changeSwitch(data) {
      this.$confirm('是否确认修改该蒸汽表开关状态？', '提示')
        .then(() => {
          delete data.codes
          if (data.powerOnOrOffState) {
            data.powerOnOrOff = '1'
          } else {
            data.powerOnOrOff = '0'
          }
          for (let i in data) {
            if (data[i] === '--') {
              data[i] = ''
            }
          }
          this.$axios
            .post(api.updatePowerOnOrOff, data)
            .then((res) => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        })
        .catch(() => {
          this.getPage()
        })
    },
    changeSwitch2(data) {
      this.$confirm('是否确认修改余额不足时蒸汽表开关状态？', '提示')
        .then(() => {
          if (data.autoOffState) {
            data.autoOff = '1'
          } else {
            data.autoOff = '0'
          }
          for (let i in data) {
            if (data[i] === '--') {
              data[i] = ''
            }
          }
          this.$axios
            .post(api.updateSteamMeterDevice, data)
            .then((res) => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        })
        .catch(() => {
          this.getPage()
        })
    },

    toCurrentPage(code) {
      this.$router.push({
        path: `/steam_ammeter_current/${code}`,
      })
    },
    deleteLine(code) {
      let codes = code.join(',')
      this.$axios
        .post(api.deleteSteamMeterDeviceByCodes, {
          codes,
        })
        .then((res) => {
          nSuccess('删除成功')
          this.getPage()
        })
        .catch(errorHandler('删除蒸汽表失败'))
    },
    // 生成蒸汽表标签
    getAmmeterTip(data) {
      console.log(data)
      this.tipDialogVisible = true
      this.tipContent = `${bus.global.yqCode}#${data.code}#H`
      this.currentsteamDeviceName = data.name
      this.getCodes()
      // this.$axios
      //   .post(api.generateCipherText, {
      //     deviceCode: data.code,
      //   })
      //   .then((res) => {
      //     this.tipDialogVisible = true
      //     this.tipContent = res.data.data
      //     this.currentElectricDeviceName = data.name
      //     this.getCodes()
      //   })
      //   .catch(errorHandler('生成标签失败'))
    },
    getCodes() {
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById('createCode'),
          content: this.tipContent,
          width: 200,
        }).catch()
      }, 100)
    },
    closeTipDialogVisible() {
      this.tipDialogVisible = false
    },
  },
  watch: {
    steamityTimeArr(val) {
      this.getsteamityPage()
    },
  },
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}

.right-slide-enter,
.right-slide-leave-active {
  transform: translateX(100%);
}

.right-slide-leave-active,
.right-slide-enter-active {
  transition: all 0.3s;
}

.window-left-box {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 50%;
  z-index: 10;
}
.window-left-box .move-enter-active,
.window-left-box .move-leave-active {
  transition: all 2s linear;
  transform: translate3d(0, 0, 0);
}
.window-left-box .move-enter,
.window-left-box .move-leave {
  transform: translate3d(100%, 0, 0);
}
.window-left-main {
  width: 100%;
  height: 100%;
  z-index: 30;
  background: #ffffff;
  padding: 10px;
  overflow: auto;
}

.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.4;
  z-index: -1;
  background-color: #000000;
  transition: opacity 0.5s ease;
}

#createCode {
  display: block;
  width: 180px !important;
  height: 180px !important;
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/AmmeterManagement/AmmeterManagement.vue